import React from 'react'
import { IndexLink, Link } from 'react-router'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import './PacienteLayout.scss'
import {actions} from '../../security/modules/actionsAuth'
import {
  Button,
  Container,
  Divider,
  Grid,
  Header,
  Icon,
  Image,
  List,
  Menu,
  Dropdown,
  Segment,
  Visibility,
} from 'semantic-ui-react'

export const PacienteLayout = ({ children }) => (
<div>
  <div>
    <Menu stackable size='huge' pointing color='teal' fixed='top' borderless inverted>
    <Container>

        <Menu.Item style={{paddingRight: '25px'}} fitted='horizontally' header>
            Doug Vet
        </Menu.Item>
      </Container>
    </Menu>
  </div>
  <div style={{paddingTop: '5em', paddingBottom: '5em'}}>
    { children }
  </div>

  <Segment inverted vertical style={{ padding: '10em 0em', backgroundColor: '#006064' }}>
    <Container>
      <Grid divided inverted stackable>
        <Grid.Row>
          <Grid.Column width={16} textAlign='center'>
            <p>2020 / © Doug Mascotas/ Todos los derechos reservados</p>
            </Grid.Column>
        </Grid.Row>
      </Grid>
    </Container>
  </Segment>

</div>
)

PacienteLayout.propTypes = {
  children: PropTypes.node,
}

const mapDispatchToProps = {
}

const mapStateToProps = (state) => ({
})

export default connect(mapStateToProps, mapDispatchToProps)(PacienteLayout)



// WEBPACK FOOTER //
// ./src/layouts/PacienteLayout/PacienteLayout.js